import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import CharacterWavingHappily from 'assets/images/characters/CarolinaMariadeJesus/waving-happily.webp';
import EvaluationQRCode from 'assets/images/comparison-letter/evaluation-QRCODE.webp';
import LogoLetrusInverted from 'assets/images/icons/inverted-letrus-logo.webp';
import styles from './EmptyLetter.module.scss';

interface EmptyLetterProps {
  studentName?: string;
  schoolName?: string;
  schoolGroupName?: string;
}

function EmptyLetter({
  schoolGroupName,
  studentName,
  schoolName,
}: EmptyLetterProps): JSX.Element {
  return (
    <div className={styles.letterWrapper}>
      <header>
        <div className={styles.letterTitle}>
          <h1>Volte a dar imaginação à sua escrita!</h1>
        </div>

        <div className={styles.studentInfo}>
          <FontAwesomeIcon icon="graduation-cap" scale="1x" />
          <p>{`${schoolName} - ${studentName} - ${schoolGroupName}`}</p>
        </div>
      </header>

      <main className={styles.letterContent}>
        <div className={styles.banner}>
          <img src={CharacterWavingHappily} alt="" aria-hidden />
          <blockquote>
            Escrever é algo mágico, é tanto a água da vida como qualquer outra
            arte criativa. <br />E a água é grátis. Então beba-a e deixe-a
            preencher você.
            <br />
            <cite>Stephen King</cite>
          </blockquote>
        </div>

        <article className={styles.letterArticle}>
          <p>
            Explorar as atividades ofertadas pela Letrus no(a) {schoolName} é
            uma oportunidade valiosa para {studentName} desenvolver habilidades
            de escrita e ampliar suas capacidades de comunicação e reflexão. É
            tempo de pensar na importância da leitura e da escrita para nossa
            vida e para nosso desenvolvimento.
          </p>

          <p>
            A Letrus é o único programa de desenvolvimento de escrita
            reconhecido pela Unesco, tendo recebido em 2020 o prestigiado prêmio
            global King Hamad Bin Isa Al-Khalifa ICT in Education Prize. Essa
            premiação reconhece o programa como a melhor iniciativa do mundo a
            unir inteligência artificial e educação, reforçando a qualidade, e a
            eficácia das atividades que {studentName} terá oportunidade de
            explorar.
          </p>

          <p>
            Ao ler e escrever, conhecemos a nós mesmos e o mundo que nos rodeia,
            pois a partir das palavras, decodificamos novas formas de ver o
            mundo e nos entender nesse espaço. Ao colocarmos em palavras o que
            vemos, pensamos e lemos, nós também lidamos e entendemos quem somos,
            nossos processos de mudanças, aprendizagens e também sentimentos.
            Com as ativiades de leitura e escira da Letrus, {studentName} pode
            ter um desenvolvimento na escrita e também pode ter um encontro com
            as possibilidades que essa atividade faz.
          </p>

          <p>
            Na Letrus, além das atividades de escrita, há materiais e trilhas
            que trabalham a leitura, que podem ser um caminho para conhecer
            novos textos e também para o desenvolvimento do leitor e autor.
          </p>

          <p>
            <b>Que tal dar uma chance para a escrita?</b>
          </p>
        </article>
      </main>

      <aside className={styles.evaluationAside}>
        <img src={EvaluationQRCode} alt="QR code para página de avaliação" />

        <p>
          Avalie e nos ajude a melhorar ❤️ Leia o QR CODE ou acesse o link:
          <br />
          <a href="https://letrus.pro/cartas" target="_blank" rel="noreferrer">
            https://letrus.pro/cartas
          </a>
        </p>
      </aside>

      <footer>
        <img src={LogoLetrusInverted} alt="" aria-hidden />
        <address>
          <a href="mailto:comunicacao@letrus.com.br">
            comunicacao@letrus.com.br
          </a>
          <br />
          <a href="https://www.letrus.com" target="_blank" rel="noreferrer">
            www.letrus.com
          </a>
          <br />
          R. Francisco Leitão, 469 - Pinheiros, São Paulo - SP, 05414-901
        </address>
      </footer>
    </div>
  );
}
export default EmptyLetter;
